import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import { Button } from 'components/form/Button/Button';
import './StandardRedesignCreditCardOfferTwo.scss';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { ReactComponent as ToolTipIcon } from 'style/_assets/art-tooltip-outline.svg';
import ApprovalOddsBadge from 'components/Offers/fragments/ApprovalOddsBadge';
import { CreditCardAdditionalText } from 'components/Fragments/CreditCardAdditionalText/CreditCardAdditionalText';
import { CreditCardPreApprovedMessage } from 'components/Fragments/CreditCardPreApprovedMessage/CreditCardPreApprovedMessage';
import classnames from 'classnames';
import { formatIncome } from 'helpers/money.helper';
import { ReactComponent as OpenInNew } from 'style_icons/open-in-new-blue.svg';
import { Tag } from 'components/Tag';
import { OffersTray } from 'components/Offers/OffersTrayCollapse/OffersTrayCollapse';
import { ReactComponent as Glitter } from 'style/_assets/icons/glitter.svg';
import { useState } from 'react';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import SesameGuarenteeDisclaimer from '../SesameGuranteeDisclaimer/SesameGuranteeDisclaimer';
import { GUARANTEE } from 'helpers/approvalOdds.helper';
import HText from 'components/CText/HText';
import { Link } from 'components/navigation/Link/Link';
import { useConfig } from 'hook/config.hook';
import OfferHeader from '../OfferHeader/OfferHeader';
import { RewardAndBonusOffer } from '../RewardAndBonusOffer';
import AmexWithConfidence from '../AmexWithConfidence/AmexWithConfidence';

const CreditLimitContainer = props => {
  const { offerMetadata, hideCreditLimitByConfig, pagePosition } = props;
  const { config } = useConfig();
  const predictedCreditLimitLabel =
    formatIncome(offerMetadata?.predictedCreditLimit) ?? formatIncome(300);
  if (offerMetadata?.hideCreditLimit || hideCreditLimitByConfig) return <></>;
  else
    return (
      <FlexContainer className={'gap-8'}>
        <CSTooltip
          title={config?.disclaimers?.predictedCreditLimitTooltip}
          placement={'bottomRight'}
          isInline={true}
          tooltipName={'Predicted Credit Limit Tooltip'}
          pagePosition={pagePosition}
        >
          <FlexContainer>
            <Label className={`mCaption caption system_neutral_n400_text`}>
              <span>You may access up to </span>
              <span>{predictedCreditLimitLabel}</span>
            </Label>
            <ToolTipIcon />
          </FlexContainer>
        </CSTooltip>
      </FlexContainer>
    );
};

const YellowBadge = props => {
  const { showBadge, offerMetadata } = props;
  if (showBadge) {
    return (
      <FlexContainer
        datatestid="creditCardOfferBadge"
        className="justify-between items-align-center margT10 m-margT6"
      >
        <Tag datatestid="creditCardOfferBadge" extClass="offerTag tagContainer">
          {offerMetadata?.badgeLabel}
        </Tag>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

const LargeCreditCardOfferExp = props => {
  const {
    offerMetadata,
    offerImageLinkUrlProxy,
    hideCreditLimitByConfig,
    showBadge,
    templateCustomClass,
    seenPixel,
    bodyContentType,
    containerType,
    clickApplyImageHandler,
    clickApplyHandler,
    clickDetailsHandler,
    clickApplyCardNameHandler,
    clickApplyDetailsHandler,
    clickTcHandler,
    position,
    pagePosition,
    hideNAFields,
    buttonLabel,
    clickFullTcHandler,
    goToViewProgramTerms,
    showBonusOfferTray,
    showRewardAndBonus,
    isHighlightFirstCard,
    showAmexWithConfidence,
    showApprovalOddsBadge,
  } = props;

  const approvalOdds = offerMetadata?.observedApprovalOdds;
  const observedApprovalOdds = offerMetadata?.observedApprovalOdds;
  const isGuarantee = observedApprovalOdds === GUARANTEE;
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);

  const isPreScreen = offerMetadata?.experienceName === 'PRE_SCREENED';

  const isPreApprovedCard =
    offerMetadata?.observedApprovalOdds === 'PRE_APPROVED';

  const showHighlightFirstCard =
    position === 1 &&
    isHighlightFirstCard &&
    (!isPreApprovedCard || isPreScreen);

  const containerStyles = classnames(
    'StandardRedesignCreditCardOffer grayShadow16 border-rad8px dashboardCreditCard',
    templateCustomClass,
    {
      border2pxBlueB100: showHighlightFirstCard,
      border2pxGreenG100: isPreApprovedCard,
    },
  );

  const collapseContainerShadow = classnames({
    showBonusTrayShadow: isCollapseOpen,
    showBonusTray: !isCollapseOpen,
  });

  const bonusOfferTrayTracking = () => {
    props?.eventHandler(CLICK, {
      'Click Type': 'Close Bonus Tray',
    });
  };

  const offerContent = () => {
    return (
      <FlexContainer className={'flex-column gap-16'}>
        <Label
          dangerouslySetInnerHTML={{
            __html: offerMetadata?.bonusOfferInfo?.bonusOfferBulletsText,
          }}
        ></Label>
        <FlexContainer className={'justify-between'}>
          <Link
            type="Subtitle-3"
            color="fontBlue100"
            className=" otherLink padL16"
            onClickCallback={e => {
              e.stopPropagation();
              clickFullTcHandler();
            }}
          >
            {offerMetadata?.bonusOfferInfo?.bonusLink?.linkTitle}
          </Link>
          <Link
            type="Subtitle-3"
            color="fontBlue100"
            className=" otherLink padL16"
            onClickCallback={e => {
              e.stopPropagation();
              setIsCollapseOpen(false);
              bonusOfferTrayTracking();
            }}
          >
            {'CLOSE'}
          </Link>
        </FlexContainer>
      </FlexContainer>
    );
  };
  const genExtra = () => <Glitter />;

  return (
    <>
      {seenPixel}
      <SectionContainer
        className={containerStyles}
        onClick={e => {
          e.stopPropagation();
        }}
        padding={'padT0'}
      >
        <OfferHeader
          showHighlightFirstCard={showHighlightFirstCard}
          isPreScreen={isPreScreen}
          cardUiModuleConfiguration={offerMetadata?.cardUiModuleConfiguration}
        >
          <FlexContainer className={'flex-column row-gap-10 pad16 m-pad24'}>
            <CreditLimitContainer
              offerMetadata={offerMetadata}
              hideCreditLimitByConfig={hideCreditLimitByConfig}
              pagePosition={pagePosition}
            />
            <FlexContainer className={'flex-column pointer gap-16'}>
              <FlexContainer
                className={'m-flex-column items-align-center flex-1 gap-16'}
              >
                <img
                  alt="credit card"
                  onClick={e => {
                    e.stopPropagation();
                    clickApplyImageHandler(e);
                  }}
                  src={offerImageLinkUrlProxy}
                  className={'borderRadius3 borderwhite pointer width100'}
                />
                <FlexContainer className="flex-column gap-16 width100 items-align-center">
                  <Button
                    mrphType={'primary'}
                    onClick={e => {
                      e.stopPropagation();
                      clickApplyHandler(e);
                    }}
                    className="applyButton applyButtonLarge"
                  >
                    <FlexContainer
                      className={classnames(
                        'justify-center align-items-center marglr10 m-marglr0',
                        { 'm-text-12': buttonLabel?.length >= 20 },
                      )}
                    >
                      {buttonLabel}
                    </FlexContainer>
                  </Button>

                  <Label
                    type="Subtitle-3"
                    color="secondary_text_light"
                    className="Body-2 otherLink width100 height16px text-center notBold"
                    onClick={e => {
                      clickDetailsHandler(e);
                    }}
                  >
                    {'View Details'}
                  </Label>
                </FlexContainer>
                <FlexContainer className="justify-start width100">
                  {showAmexWithConfidence && <AmexWithConfidence />}
                </FlexContainer>
                <FlexContainer className="justify-start width100">
                  <YellowBadge
                    showBadge={showBadge}
                    offerMetadata={offerMetadata}
                  />
                </FlexContainer>
              </FlexContainer>

              <FlexContainer
                className={'flex-column items-align-start width100'}
              >
                <HText
                  className={`Subtitle-2 secondary_text_light pointer ccContentContainer width100 margB14`}
                  html={offerMetadata?.name}
                  tabIndex="0"
                  onKeyDown={clickApplyCardNameHandler}
                  onClick={e => {
                    e.stopPropagation();
                    clickApplyCardNameHandler(e);
                  }}
                />

                <FlexContainer className={'flex-column width100'}>
                  <FlexContainer
                    className={
                      'flex-column items-align-start format60 pointer width100 gap-8'
                    }
                  >
                    <FlexContainer
                      className={
                        'align-items-start justify-between width100 gap-10'
                      }
                    >
                      <Label>
                        <Label
                          className={`Subtitle-3 system_neutral_n400_text margB8`}
                        >
                          <span className="bold">{`Annual Fee: `}</span>
                          <span>{`${offerMetadata?.annualFeeDetails} `}</span>
                        </Label>
                        <Label
                          className={`Subtitle-3 system_neutral_n400_text`}
                        >
                          <span className="bold">{`Regular APR: `}</span>
                          <span>{`${offerMetadata?.aprDetails}`}</span>
                        </Label>
                      </Label>
                      {approvalOdds && !showApprovalOddsBadge && (
                        <>
                          <ApprovalOddsBadge
                            offerMetadata={offerMetadata}
                            labelCustomClass={
                              'system_neutral_n400_text text-12 text-center'
                            }
                            isTooltipSorrounded
                            isRedesignCard
                          />
                        </>
                      )}
                    </FlexContainer>
                  </FlexContainer>
                </FlexContainer>

                <FlexContainer
                  className={'flex-column pointer margT14'}
                  onClick={e => {
                    e.stopPropagation();
                    clickApplyDetailsHandler(e);
                  }}
                >
                  {isGuarantee && (
                    <SesameGuarenteeDisclaimer
                      title={`Sesame  Guarantee: `}
                      description={`You'll be approved for this card or get $25 Sesame Cash on us! `}
                      labelClassName={`Subtitle-3 fontGray400`}
                      titleClassName={`bold`}
                      type={'Subtitle-3'}
                      className={`otherLink margT10 width68px height16px, fontBlue100`}
                      color={'fontBlue100'}
                      subtitle={'View Program Terms.'}
                      goToViewProgramTerms={goToViewProgramTerms}
                    />
                  )}
                  <CreditCardAdditionalText
                    containerType={containerType}
                    bodyContentType={bodyContentType}
                    offerMetadata={offerMetadata}
                    hideNAFields={hideNAFields}
                  />
                </FlexContainer>

                {offerMetadata?.tcUrl && (
                  <FlexContainer
                    className={'items-align-center ccContentContainer margB10'}
                    onClick={e => {
                      e.stopPropagation();
                      clickTcHandler(e);
                    }}
                  >
                    <Label
                      type="Subtitle-2"
                      color="primary_text_light"
                      className={`link notBold text-12`}
                    >
                      {offerMetadata?.tcText}
                    </Label>
                    <OpenInNew className="margL4" />
                  </FlexContainer>
                )}
                {showRewardAndBonus && offerMetadata?.bonusOfferFlag && (
                  <RewardAndBonusOffer offerMetadata={offerMetadata} />
                )}
                <FlexContainer
                  className={'flex-column width100'}
                  onClick={e => e.stopPropagation()}
                >
                  <CreditCardPreApprovedMessage
                    className={'pad10 justify-center'}
                    prePopulatedTooltipText={
                      offerMetadata.prePopulatedTooltipText
                    }
                  />
                </FlexContainer>
                {showBonusOfferTray && offerMetadata?.bonusOfferInfo && (
                  <FlexContainer className="width100">
                    <FlexContainer
                      className={'trayContainer m-hide'}
                    ></FlexContainer>
                    <FlexContainer className={'offerTrayContainer format100'}>
                      <OffersTray
                        offerMetadata={offerMetadata}
                        clickFullTcHandler={clickFullTcHandler}
                        offerContent={offerContent}
                        genExtra={genExtra}
                        isCollapseOpen={isCollapseOpen}
                        setIsCollapseOpen={setIsCollapseOpen}
                        className={'offerTray'}
                        expandIconPosition={'end'}
                        collapseContainerShadow={collapseContainerShadow}
                        key={'1'}
                        onClick={e => {
                          e.stopPropagation();
                        }}
                      />
                    </FlexContainer>
                  </FlexContainer>
                )}
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </OfferHeader>
      </SectionContainer>
    </>
  );
};

export default LargeCreditCardOfferExp;
